/*
 *
 * PaintPanel
 *
 */

import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useInjectReducer } from 'utils/injectReducer';
import { createStructuredSelector } from 'reselect';
import reducer from './reducer';
import { RootState } from './types';
import { makeSelectPaintColor } from './selectors';
import { Color } from '../../lib/modelBuilder/entities/Color';
import Panel from '../../components/Panel';
import { makeSelectIsVisibleColorsPanel } from '../Configurator/selectors/general';
import { ActivePanel } from '../Configurator/constants/general';
import { setColorsPanelAction } from '../Configurator/actions/general';
import PanesColorPicker from '../PanesPanel/PanesColorPicker';
import styled from 'styled-components/macro';
import { useInjectSaga } from '../../utils/injectSaga';
import { FiX } from 'react-icons/all';
import PaintCursor from './PaintCursor';
import { switchModeAction } from '../ModeBar/actions';
import { ConfiguratorMode } from '../ModeBar/reducer';
import StyledOverlay from '../../components/styles/StyledOverlay';
import { useTranslation } from 'react-i18next';
import PaintInstructions from '../../components/PaintInstructions';

interface StateProps {
  color: Color | undefined;
  isVisible: boolean;
}

const stateSelector = createStructuredSelector<RootState, StateProps>({
  color: makeSelectPaintColor(),
  isVisible: makeSelectIsVisibleColorsPanel(ActivePanel.paint),
});

function PaintPanel() {
  useInjectReducer({ key: 'paintPanel', reducer: reducer });
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { color, isVisible } = useSelector(stateSelector);

  const hidePanel = () => {
    dispatch(setColorsPanelAction());
    dispatch(switchModeAction(ConfiguratorMode.selector));
  };

  return (
    <>
      <Panel isVisible={isVisible} autoclose={false} close={hidePanel}>
        <PanesColorPicker paintMode={true} />

        {isVisible && !color && <PaintInstructions />}
      </Panel>
      {isVisible && !color && <StyledOverlay />}
    </>
  );
}

export default PaintPanel;
